/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,

  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_LOGIN_OTP_LIST,
  LOAD_LOGIN_OTP_LIST_SUCCESS,
  LOAD_LOGIN_OTP_LIST_ERROR,

  UPDATE_LOGIN_OTP_LIST,
  UPDATE_LOGIN_OTP_LIST_SUCCESS,
  UPDATE_LOGIN_OTP_LIST_ERROR,

  DELETE_LOGIN_OTP_LIST,
  DELETE_LOGIN_OTP_LIST_SUCCESS,
  DELETE_LOGIN_OTP_LIST_ERROR,



} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

/**
 * @param {integer} id
 */
export function loadLoginOtp() {
  return {
    type: LOAD_LOGIN_OTP_LIST,

  }
}



export function loadLoginOtpSuccess(login_otp) {
  return {
    type: LOAD_LOGIN_OTP_LIST_SUCCESS,
    login_otp,
  }
}

/**
 * @param {string} error
 */

export function loadLoginOtpError(error) {
  return {
    type: LOAD_LOGIN_OTP_LIST_ERROR,
    error,
  }
}


export function updateLoginOtp(updateLoginOtp) {
  return {
    type: UPDATE_LOGIN_OTP_LIST,
    updateLoginOtp,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateLoginOtpSuccess(updateLoginOtp, success) {
  return {
    type: UPDATE_LOGIN_OTP_LIST_SUCCESS,
    updateLoginOtp,
    success
  }
}

/**
 * @param {string} error
 */
export function updateLoginOtpError(error) {
  return {
    type: UPDATE_LOGIN_OTP_LIST_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @returns
 */
export function deleteLoginOtp(deleteLoginOtp) {

  return {
    type: DELETE_LOGIN_OTP_LIST,
    deleteLoginOtp
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteLoginOtpSuccess(
  deleteLoginOtp
) {


  return {
    type: DELETE_LOGIN_OTP_LIST_SUCCESS,
    deleteLoginOtp,
  }
}

/**
 * @param {string} error
 */
export function deleteLoginOtpError(error) {
  return {
    type: DELETE_LOGIN_OTP_LIST_ERROR,
    error,
  }
}


export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(loginMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    loginMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


const actions = {

  loadLoginOtp,
  loadLoginOtpSuccess,
  loadLoginOtpError,

  updateLoginOtp,
  updateLoginOtpSuccess,
  updateLoginOtpError,

  deleteLoginOtp,
  deleteLoginOtpSuccess,
  deleteLoginOtpError,

  loadRecordsCacheHit,

  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

}

export default actions
